export const SET_FILTER = "SET_FILTER";
export const CLEAR_FILTER = "CLEAR_FILTER";

export const setFilter = (key, value) => ({ type: SET_FILTER, key, value });
export const clearFilter = (key) => ({ type: CLEAR_FILTER, key });
